import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import FiltersHeader from '../../components/FiltersHeader';
import ButtonMenu from '../../components/FilterComponents/ButtonMenu';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import FilterToggle from '../../components/FilterComponents/FilterToggle';
import DataTable from '../../components/DataTable';
import TableControls from '../../components/TableControls';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { DropdownOptionsType, FilterMenuOptionsType } from '../../../lib/proptypes/semantic';
import {selectMapNewDropdown, selectMapOldDropdown, selectWeeksForDropdown} from '../../../store/reducers/season';
import { selectPositionsForFilterMenu, getColGroups } from '../../../store/reducers/positions';
import ColGroupsTypes from '../../../lib/proptypes/colGroups';
import { selectTracking } from '../../../store/reducers/tracking';
import { clearSelectedPlayers } from '../../../store/reducers/tableControls';
import { goToView } from '../../routes.global';
import { DataPT } from '../../components/DataTable/DataTable.proptypes';
import {
  START_BENCH_VIEW,
  selectStartBenchState,
  selectRanking,
  setTrackingToggle,
  setAnalysisToggle,
} from './module/startBench';
import classes from './StartBench.css';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

// const log = debug('huddle:app:views:startBench');
const pageTitle = 'Start Bench Tool'

// const colGroups = [{
//   columns: [
//     'player', 'team', 'bye', 'FFPTS', 'PAYDS', 'PATDS', 'INT', 'RUYDS', 'RUTDS', 'TOTYDS', 'TOTTD',
//   ],
// }];
const mapStateToProps = state => {
  const {
    position,
    year,
    formulaId,
    week,
    hasLoaded,
    showTrackedPlayers,
    showAnalysis,
  } = selectStartBenchState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const key = 'player-projections-weekly';

  var mapfunc = selectMapOldDropdown;
  if ( year >= 2021 ) {
    mapfunc = selectMapNewDropdown;
  }

  return {
    hasLoaded,
    positions: selectPositionsForFilterMenu(state, 'projections'),
    positionsCombined: selectPositionsForFilterMenu(state, 'projectionsCombined'),
    selectedPosition: position,
    selectedYear: year,
    selectedWeek: week,
    selectedProfile: formulaId,
    tracking: selectTracking(state),
    toolDescriptions,
    toolsLoaded,
    showTrackedPlayers,
    showAnalysis,
    collapsed: selectControlsState(state).collapsed,
    ...hasLoaded && {
      tableData: selectRanking(state),
      weeks: mapfunc(state, year, 'projections'),
      colGroups: getColGroups(state, key, position),
    },
  };
};
const actions = {
  goToView, setAnalysisToggle, setTrackingToggle, clearSelectedPlayers,
};
class StartBench extends PureComponent {
  static propTypes = {
    tableData: DataPT,
    hasLoaded: PT.bool.isRequired,
    toolsLoaded: PT.bool.isRequired,
    selectedYear: PT.number.isRequired,
    selectedProfile: PT.number.isRequired,
    selectedPosition: PT.string.isRequired,
    selectedWeek: PT.number.isRequired,
    positions: FilterMenuOptionsType.isRequired,
    positionsCombined: FilterMenuOptionsType.isRequired,
    weeks: DropdownOptionsType,
    goToView: PT.func.isRequired,
    tracking: PT.object.isRequired, /* eslint-disable-line react/forbid-prop-types */
    colGroups: ColGroupsTypes,
    showAnalysis: PT.bool.isRequired,
    showTrackedPlayers: PT.bool.isRequired,
    setAnalysisToggle: PT.func.isRequired,
    setTrackingToggle: PT.func.isRequired,
    clearSelectedPlayers: PT.func.isRequired,
    gciPageView: PT.func.isRequired,
  };

  static defaultProps = {
    weeks: [],
    tableData: [],
    colGroups: [],
  };

  state = {
    showAnalysis: this.props.showAnalysis,
    onlyTracked: this.props.showTrackedPlayers,
  };

  componentWillMount() {
    this.props.clearSelectedPlayers();
  }

  getTableData = () => {
    const { tracking, tableData, selectedProfile } = this.props;
    const filteredData = tableData.filter(row =>
      tracking[row.player_id] &&
      tracking[row.player_id].leagues.includes(selectedProfile));

    return this.state.onlyTracked ? filteredData : tableData;
  }

  handleChangeYear = (event, { value }) => {
    const { selectedYear, selectedProfile, selectedPosition } = this.props;

    if (selectedYear !== value) {
      this.props.goToView(
        START_BENCH_VIEW,
        {
          query: { year: value, formulaId: selectedProfile, position: selectedPosition },
          updateQuery: false,
        },
      );
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(START_BENCH_VIEW, { query: { formulaId: value } });
    }
  }

  handleChangePosition = (event, { value }) => {
    if (this.props.selectedPosition !== value) {
      this.props.goToView(START_BENCH_VIEW, { query: { position: value } });
    }
  }

  handleChangeWeek = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(START_BENCH_VIEW, { query: { week: value } });
    }
  }

  toggleAnalysis = () => this.setState(prevState => {
    this.props.setAnalysisToggle(!prevState.showAnalysis);
    return { showAnalysis: !prevState.showAnalysis };
  });


  toggleTracked = () => this.setState(prevState => {
    this.props.setTrackingToggle(!prevState.onlyTracked);
    return { onlyTracked: !prevState.onlyTracked };
  });
  // ({ onlyTracked: !prevState.onlyTracked }));

  shouldDisableToggle = (selectedPosition, selectedYear, selectedWeek) => {
    const disableThese = ['PK', 'DL', 'LB', 'DB', 'DL,LB,DB'];
    if ((selectedYear >= 2021 & selectedWeek > 18)
      | (selectedYear < 2021 & selectedWeek > 17)
      | (disableThese.includes(selectedPosition)))
      return true;
    else
      return false;
  }
  render() {
    const {
      positions,
      positionsCombined,
      weeks,
      selectedYear,
      selectedProfile,
      selectedPosition,
      selectedWeek,
      showTrackedPlayers,
      hasLoaded,
      colGroups,
      toolDescriptions,
      toolsLoaded,
    } = this.props;
    const { showAnalysis, onlyTracked } = this.state;

    // for collapsed
    const wrapperClass = classNames(
      classes.tableWrapper,
      { [classes.collapsed]: this.props.collapsed },
    );

    if (colGroups[0]) {
      colGroups[0].columns.splice(2, 0, 'opponent_team_abbr');
      colGroups[0].columns.splice(3, 0, 'bye');
      colGroups[0].fixedColumns.splice(2, 0, 'opponent_team_abbr');
      colGroups[0].fixedColumns.splice(3, 0, 'bye');
    }
    if (selectedPosition.length >= 5) {
      colGroups[0].columns.splice(1, 0, 'Pos');
      colGroups[0].fixedColumns.splice(1, 0, 'Pos');
    }

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.start_bench.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.start_bench.text}
            />)}
          seasonType={'seasons'}
          statType={'projections'}
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
        >

          <PrimaryDropdown
            choices={weeks}
            label={'Week:'}
            activeItem={selectedWeek}
            onChange={this.handleChangeWeek}
          />
          <ButtonMenu
            choices={positions}
            label={'Position:'}
            activeItem={selectedPosition}
            onChange={this.handleChangePosition}
          />
          <ButtonMenu
            choices={positionsCombined}
            label={'Combined Positions:'}
            activeItem={selectedPosition}
            onChange={this.handleChangePosition}
          />
          <div className={classes.togglesContainer}>
            {
             this.shouldDisableToggle(selectedPosition, selectedYear, selectedWeek)?
              null
            :
              <FilterToggle
                checked={showAnalysis}
                onChange={this.toggleAnalysis}
                valueOff={'NO'}
                valueOn={'YES'}
                label={'Include Analysis:'}
              />
          }

            <FilterToggle
              checked={onlyTracked}
              onChange={this.toggleTracked}
              valueOff={'NO'}
              valueOn={'YES'}
              label={'Show Only Tracked Players:'}
            />
          </div>



        </FiltersHeader>
        <TableControls injury track compare colGroups={colGroups} />
        {hasLoaded && (this.shouldDisableToggle(selectedPosition, selectedYear, selectedWeek) ?
          <DataTable
            className={wrapperClass}
            track
            compare
            injury
            selectedLeague={selectedProfile}
            showAnalysis={false}
            showTrackedPlayers={showTrackedPlayers}
            colGroups={colGroups}
            showAt={true}
            data={this.getTableData()}
          />
          :
          <DataTable
            className={wrapperClass}
            track
            compare
            injury
            selectedLeague={selectedProfile}
            showAnalysis={showAnalysis}
            showTrackedPlayers={showTrackedPlayers}
            colGroups={colGroups}
            showAt={true}
            data={this.getTableData()}
          />
        )}
      </div>
    );
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }
}
export default connect(mapStateToProps, actions)(StartBench);



// WEBPACK FOOTER //
// ./src/app/views/StartBench/StartBench.js